$(document).ready(function () {

    //hide popup when dalmar in cart
    var delmarSku = ['119-01-2975-09', '119-03-2975-09', '119-03-2976-09', '119-05-3050-44', '119-05-3049-44', '119-05-3052-28', '119-05-3053-28', '119-05-3053-29', '119-05-3053-30', '119-01-3027-34', '119-05-3027-34', '119-05-3056-09', '119-05-3059-22', '119-12-2981-34', '119-12-2987-09', '119-12-2992-30', '119-12-2992-29', '119-12-2992-28', '119-01-2996-44', '119-12-2996-44', '119-12-2997-34', '119-01-2998-29', '119-12-2998-34', '119-12-2998-34', '119-01-2999-34', '119-05-2999-34', '119-12-2999-34'];
    for (var i = 0; i < delmarSku.length; i++) {
        var productSC = $('tr[data-sku]');
        for (var j = 0; j < productSC.length; j++) {
            if (delmarSku[i] == $(productSC[j]).attr('data-sku')) {
                $('td.ShoppingCartBottomCell').css('display', 'none');
                $('.ShoppingCartSubTotalRow').css('border-top', 'none');
                $('#upsalePopupBox').attr("id", "delmarBlock");
                break;
            }
        }
    }

    //login page - inputs
    var loginInputs = $('.AccountTable').find('input[type="text"] , input[type="email"]');
    for (var i = 0; i < loginInputs.length; i++) {
        if ($(loginInputs[i]).val() != '') {
            $(loginInputs[i]).closest('tr').find('.AccountTextCell').addClass('input-focus');
        }
    }
    $(loginInputs).on('focus', function () {
        $(this).closest('tr').find('.AccountTextCell').addClass('input-focus');
    });
    $(loginInputs).focusout(function () {
        if ($(this).val() == '') {
            $(this).closest('tr').find('.AccountTextCell').removeClass('input-focus');
        }

    });

    //newsletter input fields placeholders
    var newsletterInputs = $('.cm-name, .cm-email');

    $(newsletterInputs).on('focus', function () {
        $(this).prev('label').addClass('input-focus');
    });
    $(newsletterInputs).focusout(function () {
        if ($(this).val() == '') {
            $(this).prev('label').removeClass('input-focus');
        }
    });

});